import { Chip, Divider, Paper, Stack, Typography } from '@mui/material';

const ALL_MONTHS = [
    "Mes",
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre"
];

const STATUS_LABELS = {
    'No realizado': 'Abandonado',
    'Pendiente de pago': 'Pendiente de pago',
    'Cancelado': 'Cancelado',
    'Rechazado': 'Rechazado',
    'Devolución': 'Devolución',
    'Error con pago': 'Problema con pago',
    'Desconocido': 'Estatus desconocido'
};

const PedidosFiltroAplicado = ({ previousFilter: { year, months, statuses } }) => {
    const sortMonths = (months) => {
        return months.map(e => ALL_MONTHS[e]);
    };

    if (!year) return null;

    return (
        <Paper
            variant="outlined"
            sx={{ mt: 2, p: 2, borderColor: 'info.light', bgcolor: 'rgba(3, 169, 244, 0.06)' }}
        >
            <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
                Filtros aplicados:
            </Typography>

            <Typography variant="overline" color="text.secondary">
                Periodo seleccionado
            </Typography>
            <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.25 }}>
                { `${year} · ${sortMonths([...months].sort((a, b) => a - b)).join(', ') || 'Sin meses'}` }
            </Typography>

            <Divider sx={{ my: 1.5 }} />

            <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                Estatus de pago
            </Typography>
            <Stack direction="row" flexWrap="wrap" sx={{ gap: 1 }}>
                {statuses.map(status => (
                    <Chip
                        key={status}
                        size="small"
                        variant="outlined"
                        label={STATUS_LABELS[status] || status}
                    />
                ))}
            </Stack>
        </Paper>
    );
};

export default PedidosFiltroAplicado;
